export default "__VITE_ASSET__0aea0ba5__"